import { render, staticRenderFns } from "./incidentReportDate.vue?vue&type=template&id=745b24f4"
import script from "./incidentReportDate.vue?vue&type=script&lang=js"
export * from "./incidentReportDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports